import PageHeader from "components/PageHeader";
import ReportForm from "components/ReportForm";
import { useState } from "react";
import userService from "services/user.service";
import sortAscending, { sortDescending } from "utils/sortData";
import Table from "./components/Table";

const WorkingHours = ({ isLoggedIn }) => {
  const [employeesPhotos, setEmployeesPhotos] = useState(new Map());
  const [formError, setFormError] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");
  const [workingHoursReport, setWorkingHoursReport] = useState("");
  const [sorted, setSorted] = useState(false);
  const [currentColumn, setCurrentColumn] = useState("first_name");
  const [showButton, setShowButton] = useState(false);
  const [params, setParams] = useState({
    dateFrom: "",
    dateTo: "",
    employeesList: "",
  });

  const validate = (value) => {
    if (!value) {
      return "At least one team member must be selected.";
    }

    return "";
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setParams(params);

    setShowButton(false);

    setFormError(validate(params?.employeesList));

    validate(params?.employeesList) === ""
      ? userService
          .getReport(
            "working_hours/table_data/",
            params?.dateFrom,
            params?.dateTo,
            params?.employeesList
          )
          .then(
            (response) => {
              setShowButton(true);
              setLastUpdate(response?.data?.data?.last_update);
              setWorkingHoursReport(
                (response?.data?.data?.table_data).sort((a, b) => {
                  setSorted(true);
                  return sortDescending(a, b, "first_name");
                })
              );
            },
            (error) => {
              const _content =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              setWorkingHoursReport(_content);
            }
          )
      : setWorkingHoursReport("");
  };

  const sortColumn = (columnName) => {
    if (currentColumn !== columnName) {
      setSorted(false);
      setCurrentColumn(columnName);
    }

    setSorted((prev) => !prev);

    workingHoursReport.sort((a, b) => {
      if (currentColumn !== columnName) {
        return sortDescending(a, b, columnName);
      } else {
        return sorted
          ? sortAscending(a, b, columnName)
          : sortDescending(a, b, columnName);
      }
    });

    setWorkingHoursReport(workingHoursReport);
  };

  return (
    <div className="container">
      <PageHeader title="WORKING HOURS" details={lastUpdate} />
      <ReportForm
        isLoggedIn={isLoggedIn}
        handleOnSubmit={handleOnSubmit}
        showButton={showButton}
        params={params}
        formError={formError}
        employeesPhotos={employeesPhotos}
        setEmployeesPhotos={setEmployeesPhotos}
        withTime={false}
      />
      {employeesPhotos && (
        <Table
          workingHoursReport={workingHoursReport}
          photos={Object.fromEntries(employeesPhotos)}
          sortColumn={sortColumn}
        />
      )}
    </div>
  );
};

export default WorkingHours;
